export const CredentialType = {
  MAIN: 1,
  MICRO: 2,
};
